if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      function navigation(slider, element) {
        let wrapper, dots, arrowLeft, arrowRight;

        function markup(remove) {
          wrapperMarkup(remove);
          dotMarkup(remove);
          arrowMarkup(remove);
        }

        function removeElement(element) {
          element.parentNode.removeChild(element);
        }
        function createDiv(className) {
          var div = document.createElement("div");
          var classNames = className.split(" ");
          classNames.forEach((name) => div.classList.add(name));
          return div;
        }

        function arrowMarkup(remove) {
          if (remove) {
            removeElement(arrowLeft);
            removeElement(arrowRight);
            return;
          }
          arrowLeft = createDiv("arrow arrow--left");
          arrowLeft.addEventListener("click", () => slider.prev());
          arrowRight = createDiv("arrow arrow--right");
          arrowRight.addEventListener("click", () => slider.next());

          wrapper.appendChild(arrowLeft);
          wrapper.appendChild(arrowRight);
        }

        function wrapperMarkup(remove) {
          if (remove) {
            var parent = wrapper.parentNode;
            while (wrapper.firstChild)
              parent.insertBefore(wrapper.firstChild, wrapper);
            removeElement(wrapper);
            return;
          }
          wrapper = createDiv("navigation-wrapper");
          slider.container.parentNode.appendChild(wrapper);
          wrapper.appendChild(slider.container);
        }

        function dotMarkup(remove) {
          if (remove) {
            removeElement(dots);
            return;
          }
          dots = createDiv("dots");
          slider.track.details.slides.forEach((_e, idx) => {
            var dot = createDiv("dot");
            dot.addEventListener("click", () => slider.moveToIdx(idx));
            dots.appendChild(dot);
          });
          wrapper.appendChild(dots);
        }

        function updateClasses() {
          var slide = slider.track.details.rel;
          slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled");
          slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled");
          Array.from(dots.children).forEach(function (dot, idx) {
            idx === slide
              ? dot.classList.add("dot--active")
              : dot.classList.remove("dot--active");
          });
        }

        slider.on("created", () => {
          markup();
          updateClasses();
        });
        slider.on("optionsChanged", () => {
          markup(true);
          markup();
          updateClasses();
        });
        slider.on("slideChanged", () => {
          updateClasses();
        });
        slider.on("destroyed", () => {
          markup(true);
        });
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        observer.disconnect();

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .finally(() => {
            let slider = new KeenSlider(
              ".td-product-recommendations__container",
              {
                loop: true,
                slides: {
                  perView: 1.5,
                  spacing: 15,
                },
                breakpoints: {
                  "(min-width: 750px)": {
                    slides: {
                      perView: 2.5,
                      spacing: 15,
                      loop: true,
                    },
                  },
                  "(min-width: 1024px)": {
                    slides: {
                      perView: 4,
                      spacing: 15,
                      loop: false,
                    },
                  },
                },
              },
              [navigation]
            );
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }
  customElements.define("product-recommendations", ProductRecommendations);
}
